import { z } from "zod";
import { albumSchema } from "@libs/catalog-engine-contracts/album";
import { songSchema } from "@libs/catalog-engine-contracts/song";
import { getAccessOutputSchema } from "../schema";

// The catalog's artist, as Catalog engine serves it.
export {
  artistSchema,
  searchArtistSchema,
  type Artist,
  type SearchArtist,
} from "@libs/catalog-engine-contracts/artist";

export const artistProfileSchema = z.object({
  albums: z.array(albumSchema),
  id: z.string(),
  image: z.string().nullable(),
  name: z.string().trim(),
  popularSongs: z.array(songSchema),
  pinnedAccess: getAccessOutputSchema.nullable().optional(),
});

export type ArtistProfile = z.infer<typeof artistProfileSchema>;

export const artistLibrarySchema = artistProfileSchema.extend({
  type: z.literal("artist"),
});

export type ArtistLibrary = z.infer<typeof artistLibrarySchema>;
